import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import classNames from 'classnames';
import {connectToStores} from 'epic-alt-utils/index';
import EpicGamesNavWrapper from './components/header/EpicGamesNavWrapper';
import EpicGamesFooterWrapper from './components/footer/Footer';
import MetaTags from './components/common/MetaTags';
import getRoutes from './routes/routes';
import {FooterStore, LoginStore, LocalizationStore, AppConfigStore, HeaderStore} from './stores';

@connectToStores
class App extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object,
        localizationStore: PropTypes.object,
        loginStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        headerStore: PropTypes.object,
        footerStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        msie: PropTypes.bool
    };

    static getStores() {
        return [LoginStore, LocalizationStore, AppConfigStore, HeaderStore, FooterStore];
    }

    static getPropsFromStores() {
        return {
            loginStore: LoginStore.getState(),
            localizationStore: LocalizationStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            footerStore: FooterStore.getState(),
            headerStore: HeaderStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet(),
            msie: HeaderStore.getState().msie()
        };
    }

    render() {
        const classes = classNames('unrealtournament-wrapper', {
            mobile: this.props.mobile,
            tablet: this.props.tablet,
            msie: this.props.msie
        });
        const {defaultMetaData} = this.props.appConfigStore;
        const {location} = this.props;
        const isHomeView = location.pathname.match(/unrealtournament\/.+\/$/);
        const isMapsView = location.pathname.match(/unrealtournament\/.+\/maps$/);
        const isCharactersView = location.pathname.match(/unrealtournament\/.+\/characters$/);
        const isProgressionView = location.pathname.match(/unrealtournament\/.+\/progression$/);

        const isPlayerCard = location.pathname.match(/unrealtournament\/.+\/playerCard$/);

        const routes = getRoutes();
        return (
            <Fragment>
                <MetaTags
                    meta={defaultMetaData}
                    title={this.props.localizationStore.messages['epic.unrealtournament.name']} />
                {
                    !isPlayerCard &&
                    <EpicGamesNavWrapper
                        location={this.props.location}
                        loginStore={this.props.loginStore}
                        headerStore={this.props.headerStore}
                        localizationStore={this.props.localizationStore}
                        appConfigStore={this.props.appConfigStore}
                        history={this.props.history}
                        mobile={this.props.mobile}
                        tablet={this.props.tablet} />
                }
                
                <div className={classes}>
                    {routes}
                </div>
                {
                    !(isHomeView || isMapsView || isCharactersView || isProgressionView || isPlayerCard) &&
                    <EpicGamesFooterWrapper
                        loginStore={this.props.loginStore}
                        footerStore={this.props.footerStore}
                        localizationStore={this.props.localizationStore} />
                }
           </Fragment>
        );
    }
}

export default withRouter(App);

